import { LAB_REDIRECT_URL } from '../../constants/labs';

export const checkRedirect = () => {
    const url = new URL(window.location.href);
    const loginParam = url.searchParams.get('login');

    const isUser = window.specialtyApp.userData?.id;

    if (loginParam !== null && !isUser) {
        $('#loginModal').modal();
    }
};

export const sendBill = () => {
    const element = document.getElementById('result-send-email');
    if (!element) return;

    const input = element.querySelector('input[name="email"]');
    const link = element.querySelector('a[data-bill-link]');
    if (!input || !link) return;

    const url = new URL(link.href);

    const setCorrectUrl = (value) => {
        url.searchParams.set('mail', value);
        link.href = url;
    };

    input.addEventListener('input', () => {
        setCorrectUrl(input.value);
    });

    input.addEventListener('change', () => {
        setCorrectUrl(input.value);
    });
};

// Проверяем,
// если не страница регистрации,
// то удаляем из localstorage ссылку на редирект для лаб
// Нужно для того, чтобы если человек ушёл со страницы регистрации,
// а потом вернулся, его не перенаправило на неверную ссылку
export const checkLabRedirect = () => {
    const { pathname } = window.location;
    const regexp = new RegExp(/register/gi);

    if (!regexp.test(pathname)) {
        localStorage.removeItem(LAB_REDIRECT_URL);
    }
};
